import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { Position } from '@synergy/models';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';

export const POSITIONS_REQUEST = 'POSITIONS_REQUEST';
export const POSITIONS_RECEIVED = 'POSITIONS_RECEIVED';
export const POSITION_DELETE = 'POSITION_DELETE';
export const POSITION_UPDATE = 'POSITION_UPDATE';
export const POSITION_CREATE = 'POSITION_CREATE';
export const POSITION_CREATED = 'POSITION_CREATED';
export const POSITION_FAILED = 'POSITION_FAILED';

const receivedPositions = (positions: PaginatedResponse<Position>) => {
    return {
        type: POSITIONS_RECEIVED,
        positions,
    };
};

const createdPosition = (position: Position) => {
    return {
        type: POSITION_CREATED,
        position,
    };
};

export const fetchPositions = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: POSITIONS_REQUEST });

        const response = await api.positions.cget(searchParams);

        if (response.success) {
            dispatch(receivedPositions(response.result));
        } else {
            dispatch({ type: POSITION_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deletePosition = (positionId: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.positions.deletePosition(positionId);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.positionDeleted')));
            dispatch({ type: POSITION_DELETE, positionId });
        } else {
            if (response.error?.title === 'POSITION_IS_IN_USE') {
                dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.positionInUse')));
            } else {
                dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            }
        }
    };
};

export const updatePosition = (position: Partial<Position>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: POSITION_UPDATE, position });
        const response = await api.positions.updatePosition(position);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.positionUpdated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const createPosition = (position: Partial<Position>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: POSITION_CREATE });
        const response = await api.positions.createPosition(position);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.positionCreated')));
            dispatch(createdPosition(response.result));
        } else {
            dispatch({ type: POSITION_FAILED });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
